import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.SHIP_SET_SHIP_LIST]: (state, payload) => {
    state.shipList = payload.shipList
  },
  [mutationsTypes.SHIP_GET_SHIP_DELIVERY_LIST]: (state, payload) => {
    state.shipDeliveryList = payload
  }
}

export default Mutations
